import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type { ButtonItemUIProps } from '@presentation/components';
import { absoluteFill } from '@presentation/styles';
import { BUTTON_COLOR, BUTTON_FONT_SIZE, BUTTON_HEIGHT } from './constants';

export const buttonLoadingStyle = css`
  width: 30px;
  height: 18px;
  margin-left: 10px;
`;

export const IconWrapper = styled.div<{
  position: 'right' | 'left';
}>`
  ${(props) => props.position === 'right' && 'margin-left: 5px;'}
  ${(props) => props.position === 'left' && 'margin-right: 5px;'}

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const disabledStyle = css`
  opacity: 0.5 !important;
  cursor: not-allowed;
`;

export const ButtonItem = styled.button<Required<ButtonItemUIProps>>`
  white-space: ${(props) => (props.breakSpaces ? 'break-spaces' : 'nowrap')};
  box-sizing: border-box !important;
  border-radius: ${(props) => (props.squared ? '2px' : '15px')};
  height: ${(props) => BUTTON_HEIGHT[props.size]};
  line-height: ${(props) => (props.size === 'large' ? '52px' : 'unset')};
  padding: ${(props) => (props.size === 'small' ? '0px 15px' : '0px 24px')};
  box-shadow: ${(props) => (props.shadow ? '11px 11px 21px 0 rgba(14, 92, 173, 0.24)' : 'none')};
  width: ${(props) => (props.shrink ? 'auto' : '100%')};
  display: ${(props) => (props.shrink ? 'inline-flex' : 'flex')}; // Careful with this
  align-items: center;
  justify-content: center;
  color: ${(props) =>
    BUTTON_COLOR(props.theme)[props.color][props.outlined ? 'outlined' : 'default'].text ??
    props.theme.color.dark.default};
  background-color: ${(props) =>
    BUTTON_COLOR(props.theme)[props.color][props.outlined ? 'outlined' : 'default'].background ??
    'transparent'};
  border: ${(props) => (props.outlined ? '2px solid transparent' : 'none')};
  border-color: ${(props) =>
    BUTTON_COLOR(props.theme)[props.color][props.outlined ? 'outlined' : 'default'].border ??
    BUTTON_COLOR(props.theme)[props.color][props.outlined ? 'outlined' : 'default'].text ??
    'transparent'};

  &:before {
    ${absoluteFill}
    content: '';
    border-radius: ${(props) => (props.squared ? '2px' : '15px')};
    pointer-events: none;
  }

  &:active:before {
    background: rgba(255, 255, 255, 0.2);
  }

  &:hover:before {
    background: rgba(255, 255, 255, 0.1);
  }

  ${(props) => props.disabled && disabledStyle}
  &[disabled] {
    ${disabledStyle}
  }

  text-align: center;
  font-weight: 700;
  ${(props) => `font-size: ${BUTTON_FONT_SIZE[props.size]}px;`}

  letter-spacing: 0;

  cursor: pointer;
  position: relative;
  justify-content: center;
  align-items: center;
`;
